import { formatDistance, differenceInDays, format as dateFnsFormat, type Locale, type FormatOptions } from "date-fns"
import { enUS, fr } from "date-fns/locale"
import { useTranslation } from "react-i18next"
import { TFunction } from "i18next"
import initI18n from "~/i18n"
// Map i18n language codes to date-fns locales
const localeMap: Record<string, Locale> = {
  en: enUS,
  fr: fr,
}
/**
 * Gets the date-fns locale based on the current i18n language
 */
function getDateLocale(): Locale {
  const i18n = initI18n()
  const language = i18n.language || "en"
  return localeMap[language] || enUS
}

/**
 * Locale-aware format function that uses the current i18n language
 * Automatically applies the locale based on the current i18n language setting
 */
export function format(date: Date | number | string, formatStr: string, options?: FormatOptions) {
  const locale = options?.locale || getDateLocale()
  return dateFnsFormat(date, formatStr, { ...options, locale })
}

export function formatDateSince(date: string) {
  const { t } = useTranslation()

  const now = new Date()
  const dateSince = new Date(date)
  const locale = getDateLocale()
  const distance = formatDistance(now, dateSince, { locale })

  if (now > dateSince) return t("time.since", { distance })

  return t("time.until", { distance })
}

export const formatDurationInDays = (t: TFunction) => (departureDate: Date | string, arrivalDate: Date | string) => {
  const duration = differenceInDays(departureDate, arrivalDate)
  return duration === 0 ? t("time.less_than_1_day") : t(duration === 1 ? "time.days_one" : "time.days_multiple", { count: duration })
}
